// Collection of utility functions used throughout the app
module.exports.Mobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
module.exports.Android = /Android/.test(navigator.userAgent);

// TODO: strip params that = null
module.exports.convertToSlashes = (string) => {
  const updated = string.substring(1, string.length).replace(/[&=]/g, '/');
  return updated === '' ? null : updated;
};

module.exports.openFullscreen = () => {
  if (document.body.requestFullscreen) {
    document.body.requestFullscreen({ navigationUI: 'hide' });
  } else if (document.body.mozRequestFullScreen) { /* Firefox */
    document.body.mozRequestFullScreen({ navigationUI: 'hide' });
  } else if (document.body.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
    document.body.webkitRequestFullscreen({ navigationUI: 'hide' });
  } else if (document.body.msRequestFullscreen) { /* IE/Edge */
    document.body.msRequestFullscreen({ navigationUI: 'hide' });
  }
};

module.exports.closeFullscreen = () => {
  if (document.exitFullscreen) {
    document.exitFullscreen();
  } else if (document.mozCancelFullScreen) { /* Firefox */
    document.mozCancelFullScreen();
  } else if (document.webkitExitFullscreen) { /* Chrome, Safari and Opera */
    document.webkitExitFullscreen();
  } else if (document.msExitFullscreen) { /* IE/Edge */
    document.msExitFullscreen();
  }
};

module.exports.createEl = (type, options, attributes, events) => {
  const el = document.createElement(type === 'radio' ? 'div' : type);

  if (options) Object.keys(options).forEach((key) => {
    el[key] = options[key];
  });

  if (attributes) Object.keys(attributes).forEach((key) => {
    el.setAttribute(key, attributes[key]);
  });

  if (events) Object.keys(events).forEach((key) => {
    el.addEventListener(key, events[key]);
  });

  if (type === 'select' && options.values) {
    if (options.placeholder) {
      const label = document.createElement('option');
      label.innerText = options.placeholder;
      label.value = '';
      el.appendChild(label);
    }

    options.values.forEach((value) => {
      const option = document.createElement('option');
      option.innerText = value;
      el.appendChild(option);
    });

    el.value = options.value;
  }

  if ((type === 'ul' || type === 'ol') && options.values) {
    options.values.forEach((item) => {
      const li = document.createElement('li');
      li.innerText = item;
      el.appendChild(li);
    });
  }

  if (type === 'radio') {
    options.values.forEach((item, index) => {
      const input = document.createElement('input');
      const label = document.createElement('label');
      input.id = item;
      input.type = 'radio';
      input.name = options.name;
      input.value = item;
      label.id = item;
      label.innerText = item;
      label.setAttribute('for', item);
      el.appendChild(input);
      el.appendChild(label);
      input.addEventListener('change', () => { el.setAttribute('value', item); });
      if (index === 0) {
        input.checked = true;
        el.setAttribute('value', item);
      }
    });
  }
  return el;
};

module.exports.appendChildren = (parent, ...children) => {
  children.forEach((child) => {
    parent.appendChild(child);
  });
};

module.exports.getURLParams = () => {
  const params = {
    experience: null,
    overlay: null,
  };
  const search = new URLSearchParams(window.location.search);
  Object.keys(params).forEach((param) => {
    if (search.has(param) && search.get(param) !== 'null') {
      params[param] = search.get(param);
    }
  });
  return params;
};


module.exports.setInputFieldWidth = (el) => {
  const test = module.exports.createEl('span', { className: el.className, innerText: el.value });
  document.body.appendChild(test);
  el.style.width = `${test.getBoundingClientRect().width}px`;
  test.remove();
};

module.exports.fitImageToContainer = ({ target }) => {
  target.removeEventListener('load', module.exports.fitImageToContainer);
  const imageWidth = target.naturalWidth;
  const imageHeight = target.naturalHeight;
  const containerWidth = target.parentNode.getBoundingClientRect().width;
  const containerHeight = target.parentNode.getBoundingClientRect().height;
  const ratio = imageWidth / imageHeight;
  const offsetRatio = containerWidth / containerHeight;
  if (ratio > offsetRatio) {
    target.style.height = `${containerHeight}px`;
    target.style.width = `${imageWidth * (containerHeight / imageHeight)}px`;
    target.style.top = '0px';
    target.style.left = `${((imageWidth * (containerHeight / imageHeight)) / -2) + (containerWidth / 2)}px`;
  } else {
    target.style.width = `${containerWidth}px`;
    target.style.height = `${imageHeight * (containerWidth / imageWidth)}px`;
    target.style.top = `${((imageHeight * (containerWidth / imageWidth)) / -2) + (containerHeight / 2)}px`;
    target.style.left = '0px';
  }
}; 


module.exports.createAniButton = (el, evnt) => {
  const a = module.exports.createEl('div', { className: 'lottie-player' });
  const t = module.exports.createEl('div', { className: 'txt', innerText: el.getAttribute('data-button') });
  el.appendChild(a);
  el.appendChild(t);
  if (evnt) {
    el.addEventListener('mousedown', evnt);
  }
  if (typeof el.getAttribute('data-button-event') !== 'undefined') {
    // / open window 
  }
  return a;
};

module.exports.debounce = (func, wait, immediate) => {
  let timeout;
  return () => {
    const context = this;
    const args = arguments;
    const later = () => {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};
